import BaseModal from 'components/atoms/base-modal';
import BaseButton from 'components/atoms/baseButton';
import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

interface IProps {
  isOpen: boolean;
  onCancel: () => void;
  onOk: () => void;
  isLoading?: boolean;
}
export const DeleteModalKeyNote = ({
  isOpen,
  onCancel,
  onOk,
  isLoading,
}: IProps) => {
  const { t } = useTranslation();
  return (
    <BaseModal
      title={<h5>{t('labels.deleteKeynote')}</h5>}
      zIndex={3001}
      withFooter={
        <div className={s['modal-footer-wrapper']}>
          <BaseButton
            disabled={isLoading}
            label={t('labels.cancel')}
            type="secondary"
            onClick={onCancel}
          />
          <BaseButton
            type="danger"
            loading={isLoading}
            label={t('labels.delete')}
            onClick={onOk}
          />
        </div>
      }
      onCancel={onCancel}
      open={isOpen}
    >
      <div className={s['delete-keynote-alert']}>
        <h5>{t('messages.deleteKeyNote')}</h5>
        <p>{t('messages.permanentlyDeleteKeyNote')}</p>
      </div>
    </BaseModal>
  );
};
